import { useState, useRef, useEffect } from 'react';
import { api } from '../api/client';

interface Props {
  dealId: string;
  state?: 'active' | 'archived' | 'deleted';
  onChange?: () => void;
  className?: string;
}

export function DealMenu({ dealId, state = 'active', onChange, className }: Props) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onClick(e: MouseEvent) { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); }
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  async function run(action: () => Promise<any>, confirmText?: string) {
    if (confirmText && !confirm(confirmText)) return;
    setBusy(true);
    try { await action(); onChange?.(); setOpen(false); }
    catch (e: any) { alert(e.message ?? 'failed'); }
    finally { setBusy(false); }
  }

  return (
    <div ref={ref} className={`relative inline-block ${className ?? ''}`} onClick={e => e.stopPropagation()}>
      <button onClick={() => setOpen(o => !o)} disabled={busy} className="h-7 w-7 inline-flex items-center justify-center rounded-sm hover:bg-whisper text-muted hover:text-ink" title="more">
        <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><circle cx="3" cy="8" r="1.4"/><circle cx="8" cy="8" r="1.4"/><circle cx="13" cy="8" r="1.4"/></svg>
      </button>
      {open && (
        <div className="absolute right-0 top-8 w-48 bg-bg hairline rounded-sm z-50 py-1 shadow-sm">
          {state === 'active' && <>
            <button onClick={() => run(() => api.archiveDeal(dealId))} className="w-full text-left px-3 py-1.5 text-xs hover:bg-whisper">Archive</button>
            <button onClick={() => run(() => api.trashDeal(dealId))} className="w-full text-left px-3 py-1.5 text-xs text-negative hover:bg-whisper">Move to trash</button>
          </>}
          {state === 'archived' && <>
            <button onClick={() => run(() => api.unarchiveDeal(dealId))} className="w-full text-left px-3 py-1.5 text-xs hover:bg-whisper">Restore from archive</button>
            <button onClick={() => run(() => api.trashDeal(dealId))} className="w-full text-left px-3 py-1.5 text-xs text-negative hover:bg-whisper">Move to trash</button>
          </>}
          {state === 'deleted' && <>
            <button onClick={() => run(() => api.restoreDeal(dealId))} className="w-full text-left px-3 py-1.5 text-xs hover:bg-whisper">Restore</button>
            <button onClick={() => run(() => api.purgeDeal(dealId), 'Permanently delete this deal? This cannot be undone.')} className="w-full text-left px-3 py-1.5 text-xs text-negative hover:bg-whisper">Delete forever</button>
          </>}
        </div>
      )}
    </div>
  );
}
